"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const LocalStorage_1 = __importDefault(require("./LocalStorage"));
const Observer_1 = __importDefault(require("./Observer"));
class StorageItem {
    constructor(key, value) {
        this.key = key;
        this.onChanged = new Observer_1.default();
        this.onRemoved = new Observer_1.default();
        if (value)
            this.value = value;
    }
    get value() {
        return LocalStorage_1.default.get(this.key);
    }
    set value(value) {
        if (this.value != value) {
            LocalStorage_1.default.set(this.key, value);
            this.onChanged.fire(value || undefined);
        }
    }
    remove() {
        LocalStorage_1.default.remove(this.key);
        this.onRemoved.fire(undefined);
    }
}
exports.default = StorageItem;
